<template>
  <div>
    <NuxtLayout :name='layout'>
      <template #body_page>
        <div :class="['tv-enquiry-submit']" v-if='apiLoaded'>
          <div :class="['mb-db mb-pb-81', windowWidth > TABLET ? 'flex flex-1' : '']"
               :style="[windowWidth > TABLET ? 'height: 100vh;' : '']">
            <div v-if='windowWidth > PHONE'
                 :style="['position: relative;', windowWidth > TABLET ? 'height: 100vh; width: 50vw;' : 'height:500px; width: 100%;']">

              <Carousel class='hp-100 wp-100' :wrap-around='true' :autoplay='6000' :pauseAutoplayOnHover='true'>
                <template #counter></template>
                <Slide v-for='(item, index) in desktopBanner' :key='index' class='wp-100'>
                  <img alt='' class='img-cover' style='object-position: 0 0' :src='item' />
                  <div :class='slideInfoClass' v-if='index === 0'>
                    <SlideInfo>
                      <div>
                        <div class='fs-20 lh-24 fw-700 ttu mb-12' style='letter-spacing: 6px;'>Enquire. Design. Book.
                          Travel
                        </div>
                        <div :class='titleClass' v-if='topInfo?.trip_name' v-html='topInfo?.trip_name'></div>
                        <div :class='titleClass' v-else v-html='topInfo?.title'></div>
                        <div v-if='isLDSubmit'>
                          <Rating v-if='topInfo.customers' :percent='topInfo?.rating'></Rating>
                          <span v-if='topInfo.customers' class='fs-20 fw-600 lh-28'>&nbsp;by <span class='fs-28 fw-700'>{{ topInfo.customers
                            }}</span> happy customers</span>
                        </div>
                        <div v-else>
                          <Rating :percent='topInfo?.rating'></Rating>
                          <span class='fs-20 fw-600 lh-28'>&nbsp;by <span class='fs-28 fw-700'>1,900+</span> happy customers</span>
                        </div>
                      </div>
                    </SlideInfo>
                  </div>
                  <div :class='slideInfoClass' v-if='index === 1'>
                    <SlideInfo>
                      <div :class='titleClass'>
                        For you to experience the world
                        in extraordinary ways
                      </div>
                      <AboutUsContent :hasTitle='true' />
                    </SlideInfo>
                  </div>
                  <div :class='slideInfoClass' v-if='index === 2'>
                    <SlideInfo>
                      <div :class='titleClass'>
                        Your next trip starts now
                      </div>
                      <HowItWork />
                    </SlideInfo>
                  </div>
                </Slide>
                <template #addons>
                  <CarouselNav />
                </template>
              </Carousel>

              <div class='absolute z-2 top-40 left-40'>
                <router-link class='dib'
                             :to="{ name: 'home' }" exact
                             title='Go to Homepage'
                             aria-label='Go to Homepage'>
                  <svg aria-hidden='true' width='238' height='31' viewBox='0 0 238 31' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M0 12.9637C0.527473 11.4462 0.996338 9.91849 2.19143 8.7238C4.66317 6.25307 8.46505 5.99126 11.2145 8.15696C11.3751 8.28405 11.5356 8.4086 11.9255 8.71109C11.9255 6.73858 11.9255 4.98721 11.9255 3.23584C11.928 1.18198 11.928 1.16927 13.9105 1.18453C16.7288 1.20486 16.3848 0.876956 16.3924 3.7188C16.4077 9.77106 16.3593 15.8233 16.4256 21.8756C16.4409 23.1923 16.0051 23.6422 14.7514 23.4846C14.2494 23.4211 13.7321 23.4363 13.2251 23.4821C12.3357 23.5609 11.8159 23.2609 11.9229 22.0866C10.5112 23.2101 9.15561 23.9701 7.46871 24.0235C4.2682 24.1252 1.89839 22.6661 0.675268 19.7048C0.417901 19.082 0.22424 18.4313 0 17.7933C0 16.1843 0 14.5727 0 12.9637ZM11.9255 15.3785C11.9229 15.3785 11.9204 15.3785 11.9178 15.3785C11.9178 14.6591 11.9153 13.9372 11.9178 13.2179C11.9204 12.7298 11.7777 12.3155 11.4286 11.9546C9.5149 9.9795 6.09525 10.5209 5.00208 13.0298C4.3319 14.5702 4.3421 16.1766 4.99698 17.7272C5.69009 19.3667 7.50184 20.2818 9.1658 19.9132C11.3369 19.4354 11.9255 18.683 11.9255 16.3953C11.928 16.0572 11.9255 15.7191 11.9255 15.3785Z'
                      fill='white' />
                    <path
                      d='M210.989 30.2486C210.785 30.1952 210.579 30.0859 210.38 30.0961C209.175 30.1698 208.907 29.5496 209.144 28.5125C209.228 28.1414 209.346 27.7652 209.351 27.3915C209.366 26.2553 209.804 25.9096 211.005 26.0519C212.809 26.2629 213.996 24.5344 213.334 22.8415C211.481 18.1136 209.603 13.3933 207.745 8.66534C207.243 7.38422 207.305 7.26983 208.658 7.29017C212.839 7.35117 211.784 6.66486 213.183 10.3303C214.101 12.7324 214.99 15.1421 215.905 17.5925C216.544 17.262 216.567 16.7028 216.735 16.2605C217.722 13.6475 218.698 11.0293 219.633 8.39844C219.91 7.61553 220.311 7.19866 221.197 7.27238C221.997 7.33846 222.81 7.32575 223.615 7.27746C224.663 7.21391 224.877 7.58503 224.484 8.54078C223.261 11.5173 222.087 14.5117 220.894 17.4984C219.798 20.2513 218.672 22.9915 217.62 25.7622C216.58 28.4972 214.761 30.1037 211.726 30.1139C211.563 30.1139 211.402 30.2029 211.242 30.2511C211.16 30.2486 211.073 30.2486 210.989 30.2486Z'
                      fill='white' />
                    <path
                      d='M238 20.081C236.955 22.7475 234.822 23.7998 232.129 23.9701C229.537 24.1353 227.066 23.7693 224.816 22.3306C223.947 21.7739 223.738 21.2096 224.405 20.3911C224.484 20.2945 224.535 20.1725 224.599 20.0632C225.616 18.3398 225.606 18.3601 227.308 19.3311C228.727 20.142 230.243 20.6758 231.915 20.4877C232.692 20.4013 233.467 20.2081 233.615 19.2574C233.77 18.261 233.034 17.9001 232.287 17.684C230.824 17.2595 229.311 17.0002 227.866 16.5249C225.404 15.7166 224.4 14.3185 224.405 11.9749C224.411 9.69226 225.59 7.95615 227.902 7.23425C230.962 6.28103 233.923 6.60385 236.695 8.30439C237.422 8.74922 237.628 9.23472 237.09 9.94391C236.988 10.0786 236.914 10.2337 236.83 10.3786C235.913 11.98 235.918 11.9698 234.32 11.0954C233.102 10.4269 231.793 10.099 230.401 10.2769C229.665 10.371 228.906 10.6251 228.824 11.4919C228.745 12.3435 229.492 12.6154 230.144 12.7985C231.408 13.1518 232.7 13.4034 233.966 13.7491C235.875 14.2702 237.307 15.3632 238 17.2824C238 18.2178 238 19.1481 238 20.081Z'
                      fill='white' />
                    <path
                      d='M53.257 0C54.0928 0.551592 54.8012 1.1769 54.87 2.28263C54.9515 3.59679 54.2966 4.70506 53.1601 5.09143C51.9548 5.50067 50.5941 4.99483 49.9622 3.90182C49.3226 2.79863 49.5443 1.44634 50.5228 0.551592C50.7394 0.353324 50.9865 0.183017 51.2184 0C51.8988 0 52.5766 0 53.257 0Z'
                      fill='white' />
                    <path
                      d='M125.625 0C126.461 0.551592 127.169 1.1769 127.238 2.28263C127.32 3.59679 126.665 4.70506 125.528 5.09143C124.323 5.50067 122.962 4.99483 122.33 3.90182C121.691 2.79863 121.913 1.44634 122.891 0.551592C123.108 0.353324 123.355 0.183017 123.587 0C124.267 0 124.945 0 125.625 0Z'
                      fill='white' />
                    <path
                      d='M67.881 21.3265C66.4259 22.722 64.9072 23.5024 63.0012 23.4719C59.6911 23.4185 57.2347 21.5324 56.3403 18.2508C55.8867 16.591 55.851 14.893 56.0727 13.2128C56.9569 6.55302 63.8217 4.96941 67.8376 8.63992C67.7485 7.15545 68.7142 7.25967 69.6647 7.27746C72.6664 7.33338 72.4065 6.87838 72.4142 9.96933C72.4244 14.0745 72.4218 18.1797 72.4142 22.2823C72.404 27.0153 69.4863 29.9614 64.7441 30.0859C62.2979 30.1495 59.9204 30.0554 57.7851 28.6091C56.883 27.999 56.5161 27.4169 57.2754 26.4764C57.4334 26.2807 57.543 26.0468 57.6755 25.8282C58.5215 24.4175 58.5138 24.4277 59.8185 25.3046C61.3831 26.3595 63.1286 26.6188 64.9327 26.2375C67.0248 25.7952 67.9676 24.2294 67.881 21.3265ZM67.9472 15.0201C67.751 14.133 68.3524 12.9739 67.4376 12.0334C66.3317 10.8971 64.3798 10.4701 62.8661 11.0751C61.4417 11.6444 60.5651 13.1899 60.5728 15.1192C60.5804 17.0638 61.4646 18.566 62.9247 19.1151C63.042 19.1583 63.1643 19.1939 63.2866 19.2269C66.166 19.9819 67.9472 18.4339 67.9472 15.0201Z'
                      fill='white' />
                    <path
                      d='M136.827 24.0387C131.659 24.0286 128.326 20.5563 128.339 15.2031C128.352 10.132 131.866 6.65469 136.921 6.71062C142.023 6.76654 145.542 10.3379 145.509 15.4217C145.473 20.5284 141.926 24.0489 136.827 24.0387ZM133.038 15.4827C133.056 15.7318 133.051 16.1589 133.117 16.5732C133.425 18.4872 134.911 19.9056 136.672 19.992C138.494 20.081 140.086 18.7592 140.563 16.8121C140.863 15.5793 140.782 14.3821 140.321 13.2153C139.724 11.7054 138.315 10.7395 136.796 10.7599C135.268 10.7802 133.927 11.7842 133.346 13.317C133.102 13.9652 133.056 14.6337 133.038 15.4827Z'
                      fill='white' />
                    <path
                      d='M28.2873 16.868C26.6743 16.868 25.0639 16.8833 23.4509 16.8604C22.5692 16.8477 22.4316 17.1832 22.7654 17.9484C23.6318 19.9285 25.9685 20.8487 28.532 20.1522C28.9779 20.0302 29.3907 19.7887 29.8366 19.654C30.3616 19.4938 30.7438 18.5889 31.3579 19.1278C32.0816 19.7633 32.6167 20.6123 32.976 21.5248C33.1009 21.8425 32.8256 22.0789 32.5734 22.2467C29.564 24.2243 26.2972 24.542 22.9591 23.4287C20.0032 22.4424 18.4106 20.1446 17.8602 17.14C17.0015 12.4579 19.5573 8.16204 23.8433 7.00039C29.6328 5.43204 34.961 10.0634 34.2424 16.0063C34.1482 16.7816 33.7277 16.8655 33.1263 16.863C31.5133 16.8579 29.9029 16.8604 28.2899 16.8604C28.2873 16.863 28.2873 16.8655 28.2873 16.868ZM26.1163 13.7034C27.0438 13.7034 27.9714 13.7135 28.8989 13.7008C29.6659 13.6907 29.829 13.3068 29.5844 12.618C29.0926 11.2403 27.8159 10.4294 26.0857 10.437C24.3912 10.4447 23.1375 11.3089 22.6661 12.7298C22.4418 13.406 22.661 13.6958 23.3337 13.7034C24.2612 13.711 25.1888 13.7034 26.1163 13.7034Z'
                      fill='white' />
                    <path
                      d='M101.917 16.868C100.304 16.868 98.6936 16.8858 97.0806 16.8604C96.1734 16.8477 96.0893 17.2188 96.4155 17.9611C97.2869 19.9387 99.6287 20.8512 102.187 20.1496C102.595 20.0378 102.972 19.8268 103.377 19.7048C103.925 19.537 104.34 18.6652 104.911 19.0668C105.701 19.6209 106.155 20.5462 106.593 21.4155C106.781 21.7892 106.488 22.0459 106.206 22.2569C103.303 24.4302 96.8767 25.0352 93.615 21.5324C90.5139 18.2025 90.6311 12.2621 93.8902 9.039C96.3212 6.6369 100.37 5.9938 103.461 7.52402C106.407 8.98053 108.285 12.646 107.88 16.0216C107.785 16.8045 107.342 16.8655 106.751 16.8655C105.138 16.863 103.527 16.8655 101.914 16.8655C101.917 16.863 101.917 16.8655 101.917 16.868ZM99.7714 13.7085C100.658 13.7085 101.542 13.7085 102.429 13.7085C103.349 13.7085 103.512 13.2814 103.176 12.4909C102.59 11.1157 101.361 10.3964 99.593 10.437C98.0183 10.4752 96.8945 11.2632 96.3543 12.6205C96.0307 13.4339 96.3263 13.7161 97.1162 13.711C97.9979 13.7059 98.8847 13.711 99.7714 13.7085Z'
                      fill='white' />
                    <path
                      d='M202.356 16.8655C200.786 16.8655 199.217 16.8528 197.647 16.8706C196.505 16.8833 196.393 17.1019 196.913 18.1492C197.856 20.0429 200.185 20.8512 202.667 20.1217C203.11 19.992 203.523 19.7531 203.964 19.6057C204.448 19.443 204.83 18.6042 205.376 19.11C206.112 19.7887 206.721 20.6326 207.019 21.6239C207.101 21.8883 206.826 22.0637 206.634 22.234C201.956 26.4256 193.325 23.66 191.985 17.5391C190.953 12.8264 193.358 8.35014 197.604 7.07156C203.47 5.30494 208.943 9.88799 208.275 15.9809C208.191 16.7409 207.807 16.8706 207.185 16.8655C205.572 16.8553 203.961 16.863 202.348 16.863C202.356 16.863 202.356 16.8655 202.356 16.8655ZM200.131 13.7034C200.131 13.7059 200.131 13.7085 200.131 13.711C201.018 13.711 201.902 13.7059 202.789 13.711C203.658 13.7161 203.933 13.3653 203.587 12.5239C203.006 11.1132 201.732 10.371 199.9 10.4396C198.366 10.4955 197.181 11.3597 196.717 12.7044C196.493 13.3526 196.648 13.6907 197.346 13.7008C198.276 13.7135 199.204 13.7034 200.131 13.7034Z'
                      fill='white' />
                    <path
                      d='M157.686 21.9341C155.582 23.8125 153.38 24.1887 151.015 23.9676C148.74 23.7541 147.012 22.0789 146.969 19.8116C146.9 16.0013 146.959 12.1884 146.933 8.37556C146.928 7.53927 147.277 7.26475 148.077 7.27746C151.984 7.33846 151.357 6.79196 151.408 10.4091C151.438 12.6536 151.395 14.8981 151.428 17.1426C151.459 19.1125 152.373 20.02 154.208 19.9946C156.265 19.9666 157.674 18.7541 157.679 16.9824C157.686 14.2296 157.72 11.4741 157.664 8.7238C157.641 7.61807 158.023 7.2317 159.139 7.26221C162.681 7.36388 162.115 6.83517 162.146 10.1829C162.179 14.0796 162.1 17.9789 162.184 21.873C162.212 23.1948 161.758 23.6371 160.505 23.4821C160.003 23.4211 159.483 23.4312 158.978 23.4795C158.081 23.566 157.577 23.2457 157.686 21.9341Z'
                      fill='white' />
                    <path
                      d='M79.3146 8.81785C81.3557 7.04615 83.4758 6.54285 85.815 6.77416C88.2613 7.01564 89.9915 8.74922 90.0221 11.2022C90.068 14.8854 90.0119 18.5686 90.0527 22.2518C90.0629 23.205 89.6959 23.5024 88.7786 23.4846C85.0557 23.4058 85.6163 23.9625 85.573 20.353C85.5449 18.1085 85.5857 15.864 85.5526 13.622C85.522 11.6521 84.6072 10.7395 82.7776 10.7599C80.7314 10.7827 79.307 12.013 79.2994 13.7847C79.2892 16.5376 79.256 19.2905 79.3146 22.0408C79.3376 23.1542 78.9375 23.5227 77.8316 23.4922C74.2947 23.3931 74.863 23.9167 74.8324 20.5665C74.7993 16.6291 74.8655 12.6917 74.7993 8.7543C74.7789 7.55707 75.207 7.14528 76.3435 7.27492C76.7614 7.32321 77.192 7.29525 77.615 7.28C78.5451 7.24187 79.493 7.15545 79.3146 8.81785Z'
                      fill='white' />
                    <path
                      d='M179.639 8.8814C181.746 7.05377 183.861 6.54285 186.201 6.77416C188.652 7.01564 190.39 8.74159 190.42 11.192C190.469 14.8752 190.413 18.5584 190.451 22.2416C190.461 23.1796 190.122 23.5075 189.19 23.4872C185.449 23.4084 186.015 23.9599 185.971 20.3682C185.943 18.0831 185.987 15.7954 185.946 13.5102C185.913 11.6394 184.98 10.7548 183.191 10.7599C181.616 10.7649 179.555 11.9546 179.654 13.65C179.817 16.4359 179.659 19.2371 179.715 22.0306C179.736 23.1287 179.369 23.5304 178.248 23.4973C174.675 23.3931 175.266 23.9498 175.236 20.4572C175.2 16.5198 175.256 12.5824 175.21 8.645C175.198 7.58757 175.562 7.17324 176.607 7.27746C177.111 7.3283 177.623 7.29017 178.133 7.28508C179.01 7.27492 179.975 7.13511 179.639 8.8814Z'
                      fill='white' />
                    <path
                      d='M41.6423 23.9752C39.4637 24.0438 37.4506 23.5151 35.5802 22.384C34.6884 21.8451 34.4488 21.3316 35.068 20.3555C36.2835 18.4364 36.2173 18.4211 38.2227 19.4735C39.5528 20.17 40.9543 20.658 42.4934 20.4953C43.3165 20.4089 44.1498 20.2411 44.2899 19.2218C44.4275 18.2229 43.6631 17.8873 42.9215 17.6738C41.4971 17.262 40.0243 17.0104 38.6151 16.5554C35.9676 15.6988 34.961 14.2194 35.0833 11.5428C35.1827 9.36182 36.4695 7.97394 38.396 7.31305C41.5251 6.24036 44.5753 6.57081 47.4267 8.3476C48.1045 8.76955 48.2829 9.23726 47.7886 9.9007C47.7376 9.96933 47.7045 10.0481 47.6612 10.1218C46.6342 11.9444 46.6368 11.9368 44.8097 11.0064C43.6095 10.3964 42.3355 10.099 40.99 10.2972C40.2995 10.3989 39.5936 10.6607 39.4968 11.4589C39.3923 12.3206 40.1236 12.59 40.776 12.7959C42.4323 13.3145 44.2007 13.4441 45.7933 14.1863C47.5924 15.0252 48.6524 16.3749 48.7441 18.4211C48.8384 20.5538 47.9134 22.0891 46.0736 23.0982C45.0569 23.6549 43.9536 23.9549 42.7865 23.9777C42.4068 23.9828 42.0246 23.9752 41.6423 23.9752Z'
                      fill='white' />
                    <path
                      d='M126.95 17.2315C126.787 19.7353 127.279 22.8364 126.713 25.8943C126.137 29.0082 122.832 30.9375 119.805 30.0402C119.357 29.908 119.189 29.6385 119.189 29.2141C119.191 28.7082 119.209 28.1998 119.214 27.694C119.222 26.8374 119.405 26.2604 120.509 26.3087C121.444 26.3493 122.06 25.7494 122.272 24.7937C122.427 24.087 122.483 23.3779 122.483 22.656C122.476 18.0068 122.511 13.3551 122.458 8.70601C122.445 7.58503 122.81 7.2317 123.918 7.26475C127.371 7.36643 126.915 6.81229 126.948 10.3176C126.966 12.4299 126.95 14.5448 126.95 17.2315Z'
                      fill='white' />
                    <path
                      d='M113.769 8.70855C114.918 7.87989 115.922 7.17832 117.137 6.89617C118.442 6.59115 118.755 6.81992 118.794 8.12391C118.799 8.29422 118.796 8.46198 118.796 8.63229C118.804 10.7192 118.804 10.7192 116.763 11.0395C114.502 11.3928 113.7 12.3104 113.7 14.5473C113.7 17.0866 113.672 19.626 113.71 22.1654C113.725 23.1491 113.361 23.5126 112.367 23.4897C108.629 23.4007 109.274 23.9498 109.238 20.4496C109.197 16.5554 109.268 12.6612 109.205 8.76955C109.187 7.59265 109.582 7.14274 110.734 7.27746C111.195 7.33084 111.669 7.32067 112.133 7.27746C113.088 7.18595 113.822 7.36134 113.769 8.70855Z'
                      fill='white' />
                    <path
                      d='M169.281 8.76955C170.542 7.79346 171.612 7.11732 172.889 6.85042C173.796 6.65978 174.418 6.84534 174.344 7.95106C174.334 8.11883 174.346 8.28913 174.346 8.45944C174.364 10.676 174.364 10.676 172.237 11.0547C169.961 11.4614 169.25 12.3104 169.25 14.6261C169.25 17.0816 169.217 19.537 169.265 21.99C169.286 23.0372 169.011 23.5304 167.841 23.4973C164.223 23.388 164.821 23.9472 164.788 20.4979C164.753 16.6469 164.778 12.7959 164.781 8.94494C164.783 7.29271 164.788 7.29271 166.49 7.28508C166.913 7.28254 167.342 7.31559 167.762 7.27746C168.687 7.19358 169.383 7.37659 169.281 8.76955Z'
                      fill='white' />
                    <path
                      d='M54.5795 15.3836C54.5769 17.6662 54.5565 19.9514 54.5897 22.234C54.6024 23.1592 54.2406 23.5075 53.3105 23.4872C49.4755 23.4007 50.1609 23.9752 50.1227 20.386C50.0794 16.4969 50.1482 12.6053 50.0921 8.71617C50.0768 7.60791 50.4208 7.2317 51.542 7.26475C54.9999 7.36897 54.5463 6.80975 54.582 10.3099C54.5948 12.0003 54.582 13.6932 54.5795 15.3836Z'
                      fill='white' />
                  </svg>
                </router-link>
              </div>
            </div>

            <div :class="[windowWidth > TABLET ? 'px-40 py-80' : '']"
                 :style="[windowWidth > TABLET ? 'height: 100vh; width:50vw; overflow: auto;' : '']">
              <TopSection :topInfo='topInfo'></TopSection>
              <div class='' ref='topFormRef'>
                <div class='relative'>
                  <!--          <h1 class="fs-28 lh-1 fw-700 mb-20 mt-20">Let's make your trip curated and extraordinary</h1>
                            <div class="fw-16 lh-1 fw-400 mb-20">Tell us what you are looking for in your trip and we'll take care of the rest.</div>-->
                  <!--                <div v-if='windowWidth > PHONE' class="fw-16 lh-1 fw-400 mb-20 underline hand" @click="modalActiveHIW = true">How It Works?</div>-->
                  <div class='content-form'>
                    <FormSection title='Travel Information'>
                      <label :class='cssLabelField' ref='destinationRef'>Destination</label>
                      <div :class="['relative',cssFormField, modalSeasonActive?' hide-dropdown': '']">
                        <MultipleSelect
                          placeHolderText='Destination'
                          :options='dataDestination'
                          :popularDestinations='popularDestinations'
                          v-model='dataStep.destination'
                        ></MultipleSelect>
                        <div class='error-message' v-if='errorsDestination'>This is a required field.</div>
                      </div>
                      <label :class='cssLabelField' ref='lengthOfTripRef'>Length of Trip</label>
                      <div :class="[cssFormField,modalSeasonActive?' hide-dropdown': '']">
                        <SelectBox
                          placeholder='Length of Trip'
                          :noPlaceholder='true'
                          no-background
                          :options='dataLengthTrip'
                          v-model:optionSelected='dataStep.trip'
                        ></SelectBox>
                        <div class='error-message' v-if='errorsLengthOfTrip'>This is a required field.</div>
                      </div>
                      <label :class='cssLabelField' ref='monthOfTravelRef'>When do you want to travel?</label>
                      <div :class="[cssFormField, modalSeasonActive?' hide-dropdown': '']">
                        <SelectBox
                          placeholder='Start Month'
                          :noPlaceholder='true'
                          no-background
                          :options='dataMonth'
                          v-model:optionSelected='dataStep.month'
                        ></SelectBox>
                        <div class='error-message' v-if='errorsMonth'>This is a required field.</div>
                      </div>
                      <label :class='cssLabelField' ref='numOfTravellersRef'>How many travellers?</label>
                      <div :class='cssFormField'>
                        <Input
                          type='number'
                          placeholder='0'
                          v-model='dataStep.numOfTravellers'
                        ></Input>
                        <div class='error-message' v-if='errorsNumOfTravellers'>This is a required field.</div>
                      </div>
                    </FormSection>
                    <FormSection subTitle='So we can reach out to discuss your enquiry.' title='Contact Details'>
                      <label :class='cssLabelField' ref='contactNameRef'>Your name</label>
                      <div :class='cssFormField'>
                        <Input
                          type='text'
                          placeholder=''
                          name='contact_name'
                          id='contact_name'
                          v-model='dataStep.contactName'
                        ></Input>
                        <div class='error-message' v-if='errors.contact_name'>This is a required field.</div>
                      </div>
                      <label :class='cssLabelField' ref='contactEmailRef'>Your email address</label>
                      <div :class='cssFormField'>
                        <Input
                          type='email'
                          name='email'
                          placeholder='Email'
                          id='email'
                          :disabled='disableEmail'
                          v-model='dataStep.email'
                          autocomplete='email'
                        />
                        <div class='error-message' v-if='errors.email'>
                          {{ errors.email }}
                        </div>
                      </div>
                      <label :class='cssLabelField' ref='contactPhoneRef'>Your phone number</label>
                      <div :class='cssFormField'>
                        <CountrySelect
                          typeCountry='text'
                          placeholderCountry='Country'
                          placeholderPhone='Phone'
                          :valueDataCountry='dataStep.nationality'
                          v-model:country='dataStep.nationality'
                          v-model:phone='dataStep.phone'
                        />
                        <div :class="[phoneMsg ? 'error-message' : 'warning-message']" v-if='errors.phone'>
                          {{ errors.phone }}
                        </div>
                      </div>
                    </FormSection>
                    <div class='flex items-center mb-mt-12 mb-px-20'>
                      <CheckBox
                        id='newsletter'
                        name='newsletter'
                        label=''
                        v-model='dataStep.check_newsletter'
                      ></CheckBox>
                      <span class='fs-14 lh-20 mb-16'>
                        Stay up-to-date with the latest travel insights, inspirations and deals.
                      </span>
                    </div>

                    <div v-if='error' class='pb-30 red error-bottom'>{{ error }}</div>
                    <div
                      :class="['button-wrapper', windowWidth <= PHONE ? 'phone-wrapper px-20 pt-10 pb-32 bd-t-1 bd-gray-300-new flex justify-between items-center' : 'mb-20']">
                      <div v-if='windowWidth <= PHONE' class='hand flex items-center hiw-link' @click='modalActiveHIW = true'>
                        <svg aria-hidden='true' width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
                          <path
                            d='M7.33331 11.9999H8.66665V10.6666H7.33331V11.9999ZM7.99998 1.33325C4.31998 1.33325 1.33331 4.31992 1.33331 7.99992C1.33331 11.6799 4.31998 14.6666 7.99998 14.6666C11.68 14.6666 14.6666 11.6799 14.6666 7.99992C14.6666 4.31992 11.68 1.33325 7.99998 1.33325ZM7.99998 13.3333C5.05998 13.3333 2.66665 10.9399 2.66665 7.99992C2.66665 5.05992 5.05998 2.66659 7.99998 2.66659C10.94 2.66659 13.3333 5.05992 13.3333 7.99992C13.3333 10.9399 10.94 13.3333 7.99998 13.3333ZM7.99998 3.99992C6.52665 3.99992 5.33331 5.19325 5.33331 6.66659H6.66665C6.66665 5.93325 7.26665 5.33325 7.99998 5.33325C8.73331 5.33325 9.33331 5.93325 9.33331 6.66659C9.33331 7.99992 7.33331 7.83325 7.33331 9.99992H8.66665C8.66665 8.49992 10.6666 8.33325 10.6666 6.66659C10.6666 5.19325 9.47331 3.99992 7.99998 3.99992Z'
                            fill='currentColor' />
                        </svg>
                        <span class='fw-16 lh-24 fw-500 underline pl-10'>How It Works?</span>
                      </div>
                      <div class='mb-wp-50'>
                        <ButtonLoading v-if='disableSubmitButton'
                                       btnLabel='Enquire Now'
                                       :btnClass='submitButtonClass' />
                        <button v-if='!disableSubmitButton' id='traveller-submit-enquiry'
                                :class="[submitButtonClass, disableSubmitButton ? 'cursor-wait pointer-none' : '']"
                                type='button'
                                @click='submitEnquiry()'>
                          Enquire Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </NuxtLayout>
    <ModalHowItWorks
      :modal-active='modalActiveHIW'
      @closeModal='modalActiveHIW = false'
    />
    <PopupCommon
      :modalTitle='``'
      :contentCustomClass='`customClass pa-20`'
      :modalActive='modalSeasonActive'
      @update:close='modalSeasonActive = false'
    >
      <template #content>
        <div>
          <img class='absolute top-20' :src='`${ASSETS_CDN}/icons/featured-icon.svg`' width='48' height='48'
               alt='Linked icon' />
        </div>
        <div class='fs-18 lh-28 fw-700 mb-8 mt-36'>
          You're about to cancel your enquiry
        </div>
        <p class='fs-14 fw-500 lh-20 mb-24 muted-sand'>Don't miss out on your exclusive personalised trip plan. Our
          in-destination experts will design something specifically for you, including everything you are looking for in
          a perfect trip.</p>
        <div>
          <button class='button button-primary wp-100 mb-12' @click='handleCountinue(e)'>
            Continue Enquiring
          </button>
          <button v-if='goToHome' class='button button-outline wp-100' @click='handleCancelHome()'>
            Cancel Anyway
          </button>
          <button v-else class='button button-outline wp-100' @click='handleCancel()'>
            Cancel Anyway
          </button>
        </div>
      </template>
    </PopupCommon>
  </div>
</template>

<script setup>
import PopupCommon from '~/components/ui/popup/PopupCommon'
import { ref, computed, watch, reactive, nextTick, onMounted } from 'vue'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router'
import { getCookie, setCookie } from '~/mixins/cookie'
import useFormValidation from '~/utils/validators'
import enquiryTravellerApi from '~/composables/api/enquiryTravellerApi'
import {
  getCountryPhone,
  groupContinent,
  isEmpty,
  getLoopMonth,
  getMonthNumberFromText,
  exchangeRate,
  formatCurrency,
  assetCDN,
} from '~/helper'
import MultipleSelect from '~/components/ui/multiple-select/MultipleSelect'
import SelectBox from '~/components/ui/selectbox/SelectBox'
import CountrySelect from '~/components/ui/country-selectbox/CountrySelect'
import Input from '~/components/ui/input/Input'
import parsePhoneNumber from 'libphonenumber-js'
import countryList from '~/components/ui/country-selectbox/country.json'
import accountApi from '~/composables/api/accountApi'
import ButtonLoading from '~/components/ui/loading-button/ButtonLoading'
import galleryApi from '~/composables/api/galleryApi'
import { load } from 'recaptcha-v3'
import { TRAVELLER_TRIP_LENGTH } from '~/enum/tripLength.enum'
import { debounceHeapTracking } from '~/mixins/heap'
import ModalHowItWorks from '~/components/ui/modal-how-it-work/ModalHowItWorks.vue'
import TopSection from '~/components/pages/Enquiry/SectionsSubmitEnquiry/TopSection.vue'
import { PHONE, TABLET, ERROR_MESSAGE_PHONE } from '~/constant/common'
import { META } from '~/constant/enquiryCapture'
import FormSection from '~/components/pages/Enquiry/SectionsSubmitEnquiry/FormSection.vue'
import Slide from '~/components/ui/carousel/Slide'
import Carousel from '~/components/ui/carousel/CarouselHomeBanner'
import CarouselNav from '~/components/ui/carousel/Pagination'
import CheckBox from '~/components/ui/checkbox/CheckBox'
import HowItWork from '~/components/ui/how-it-work-popup-content/HowItWorkContent'
import AboutUsContent from '~/components/ui/how-it-work-popup-content/AboutUsContent'
import SlideInfo from '~/components/pages/Enquiry/SectionsSubmitEnquiry/SlideInfo.vue'
import Rating from '~/components/pages/Enquiry/Sections/Rating.vue'
import { gtmTracking } from '~/mixins/gtm.js'
import { EnquiryOptionLevel, EnquiryOptionType } from '~/enum/enquiry'
import { useLocalDesignerStore } from '~/store/pinia/localDesigner'
import { useCurrenciesStore } from '~/store/pinia/currencies'
import { useTripPlanStore } from '~/store/pinia/tripPlan'
import { useAuthStore } from '~/store/pinia/auth'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

/*definePageMeta({
  layout: false,
})*/

/*  onBeforeRouteUpdate((to, from, next) => {
    next((vm) => {
      vm.oldRoute = from.name
    })
  })*/
const layout = 'no-footer-layout'
const ASSETS_CDN = assetCDN()
const router = useRouter()
const route = useRoute()
const localDesignerStore = useLocalDesignerStore()
const authStore = useAuthStore()
const { isChrome, isEdge, isFirefox, isSafari } = useDevice()
const cssLabelField = 'fw-600 fs-16 lh-24 mb-4 db'
const cssFormField = 'one-column mb-12'
const showDestination = ref(true)
const tripName = ref('')
// const currentPosition = ref(2)
const popularDestinations = ref([])
const oldRoute = ref('')
const dataDestination = ref([])
const minBudgetDefault = ref(2000)
const minBudget = ref(0)
const minBudgetCurrency = ref('')
const minBudgetCurrencyDefault = ref('AUD')
const dataStep = reactive({
  destination: [],
  month: {},
  trip: {},
  numOfTravellers: null,
  currency: 'AUD',
  budget: '',
  notes: '',
  email: '',
  phone: '',
  fname: '',
  lname: '',
  nationality: '',
  redirect_url: '/design/confirmation',
  affiliate_id: 0,
  tripId: '',
  contactName: '',
  check_newsletter: true,
})
const errorsDestination = ref(false)
const errorsMonth = ref(false)
const disableEmail = ref(false)
const countries = ref(countryList)
const userInfo = computed(() => authStore.getUserInfo)
// const messageError = ref('')
const error = ref('')
const disableSubmitButton = ref(false)
const apiLoaded = ref(false)
// const errorsBudget= ref(false)
const errorsNumOfTravellers = ref(false)
const errorsLengthOfTrip = ref(false)
// const errorsContactName = ref(false)
const modalActiveHIW = ref(false)
const dataTripLoaded = ref({})
const dataLDLoaded = ref({})
const dataLengthTrip = ref(TRAVELLER_TRIP_LENGTH)
const submitButtonClass = 'button button-accent wp-100' // v2 (V27): enquiry conversion submit → gold Accent
const destinationRef = ref(null)
const lengthOfTripRef = ref(null)
const monthOfTravelRef = ref(null)
const numOfTravellersRef = ref(null)
const topFormRef = ref(null)
const contactNameRef = ref(null)
const contactEmailRef = ref(null)
const contactPhoneRef = ref(null)
const topInfo = reactive({
  title: `Design a Private Trip with our Local Designers for Free`,
  trip_name: '',
  rating: 91,
  bg: `${ASSETS_CDN}/images/enquiryB2C/mob_top_section_bg.jpg`,
  customers: 0,
})
const modalSeasonActive = ref(false)
const slideInfoClass = 'absolute bottom-0 left-0 z-3 wp-100 hp-100 bg-linear-gradient flex justify-end items-end white'
const titleClass = 'fs-36 lh-46 tl-fs-28 tl-lh-32 fw-700 pb-24 mb-24 bd-b-1 bd-white wp-100'
const phoneMsg = ref('')
// const GTMTracking = ref({})
const recaptcha = ref(null)
const currenciesStore = useCurrenciesStore()
const tripPlanStore = useTripPlanStore()
const generalStore = useGeneralInfoStore()

const imgNameBanner = computed(() => {
  const windowWidth = generalStore.generalData.windowWidth
  if (windowWidth > TABLET) return 'desk_'
  return 'tab_'
})

let desktopBanner = [
  `${ASSETS_CDN}/images/enquiryB2C/${imgNameBanner.value}02.jpg`,
  `${ASSETS_CDN}/images/enquiryB2C/${imgNameBanner.value}03.jpg`,
]

const desktopFirstSlide = `${ASSETS_CDN}/images/enquiryB2C/${imgNameBanner.value}01.jpg`

const trip_plan_name = computed(() => tripPlanStore?.dataTrip?.name)
// const price_per_traveller = computed(() => store.state.tripPlanStore?.priceDisplayGallery?.perPerson)
const local_designer = computed(() => {
  switch (oldRoute.value) {
    case 'local-designer':
      return localDesignerStore?.designer?.name
    case 'trip-plan':
      return tripPlanStore?.dataTrip?.designer?.name
    default:
      return ''
  }
})
const dataTrip = computed(() => tripPlanStore.dataTrip)
const budgetText = computed(() => {
  let moneyText = `Please consider the travelling season as prices vary substantially based on the actual travel dates.`
  if (route.name === 'enquiry-submit-trip' && dataStep.numOfTravellers) {
    moneyText = `The selected trip costs from ${minBudgetCurrency.value} ${formatCurrency(minBudget.value, minBudgetCurrency.value, true)} for ${dataStep.numOfTravellers || 1} travellers in low season. Please consider the travelling season as prices vary substantially based on the actual travel dates.`
  }
  return moneyText
})

const currenciesListData = computed(() => currenciesStore.getCurrenciesList /*store.getters['currenciesStore/getCurrenciesList']*/)
const currencySelected = computed(() => {
  return currenciesStore.currencySelected //store.state.currenciesStore.currencySelected
})
const submitFromSource = computed(() => {
  const routesSource = [ 'enquiry-submit-trip', 'enquiry-submit-ld' ]
  return routesSource.includes(route.name)
})
const goToPrev = () => {
  // console.log('=== back ===',router.options.history.state.back)
  if (router.options.history.state.back !== null) {
    router.go(-1)
  }
}

const selectedCurrency = computed(() => {
  // return store.getters['currenciesStore/getCurrencySelected']
  return currenciesStore.getCurrencySelected
})


useHead({
  title: computed(() => {
    const title = META.TITLE
    return title
  }),
  meta: computed(() => {
    const title = META.TITLE
    const description = META.DESCRIPTION
    return [
      {
        name: `title`,
        content: title,
      },
      {
        name: `description`,
        content: description,
      },
    ]
  }),
  link: [
    { rel: 'canonical', href: route.path, hreflang: 'en' },
  ],
})

const heapTrackingSubmit = (dataSubmit) => {
  debounceHeapTracking('Submit Enquiry', {
    // source_widget: "test"
    type: 'b2c',
    destination: dataStep.destination?.map(item => item.name.replace(',', '')).join(', ') || dataTrip?.value?.map_note?.destinations || '',
    trip_plan_name: oldRoute.value === 'trip-plan' ? trip_plan_name.value : '',
    local_designer: local_designer.value || '',
    budget_per_traveller: dataSubmit?.enquiry_infos?.budget_per_traveller || 0,
    currency: currencySelected.value.code || '',
    budget_per_traveller_converted: dataSubmit?.enquiry_infos?.budget_per_traveller_converted || 0,
    length_of_stay: dataStep.trip.value || '',
    activity_type: dataTrip.value?.activity_types?.map(item => item.name.replace(',', '')).join(', ') || '',
    start_month_year: dataStep?.month?.name || '',
    budget_total: dataSubmit?.enquiry_infos?.budget_total || '',
    budget_total_converted: dataSubmit?.enquiry_infos?.budget_total_converted || '',
    number_of_travellers: dataStep.numOfTravellers || '',
    has_additional_notes: dataStep.notes || '',
    suggested_min_budget_per_traveller: minBudget.value ? minBudget.value + ' ' + minBudgetCurrency.value : '',
    email_traveller: dataStep.email || '',
    enquiry_id: dataSubmit?.enquiry_id || '',
    error_location: dataSubmit?.error_location || '',
    error_message: dataSubmit?.error || '',
  }, 0)
}

/* Get month */
const getMonthData = getLoopMonth(25)
const dataMonth = getMonthData.map((item, index) => {
  if (index === getMonthData.length - 1) {
    item = item + '+'
  }
  return {
    name: item,
  }
})

const {
  validateNameField,
  validateEmailField,
  validatePhoneNumberField,
  errors,
} = useFormValidation()

const deviceInfo = () => {
  if (isChrome) return 'Chrome'
  if (isEdge) return 'Edge'
  if (isFirefox) return 'Firefox'
  if (isSafari) return 'Safari'
  return ''
}
const beforeUnloadHandler = (event) => {
  event.preventDefault()
  event.returnValue = true
}
if (process.client) {
  window.addEventListener('beforeunload', evt => {
    if (disableSubmitButton.value == false && (route.name === 'enquiry-submit-trip' || route.name === 'enquiry-submit-destination' || route.name === 'enquiry-submit-global' || route.name === 'enquiry-submit-ld')) {
      beforeUnloadHandler(evt)
    }
  })
}
const submitEnquiry = async () => {
  error.value = ''
  
  // validateNameField('first_name', dataStep.fname)
  // validateNameField('last_name', dataStep.lname)
  validateNameField('contact_name', dataStep.contactName)
  validateEmailField('email', dataStep.email)
  // validatePhoneNumberField('phone', dataStep.phone, dataStep.nationality)
  // errorsBudget.value = isEmpty(dataStep.budget)
  errorsNumOfTravellers.value = !dataStep.numOfTravellers > 0
  errorsDestination.value = dataStep.destination.length === 0
  errorsLengthOfTrip.value = Object.keys(dataStep.trip).length === 0
  errorsMonth.value = Object.keys(dataStep.month).length === 0
  
  let dest = []
  
  dest = dataStep.destination.map(function(item) {
    return {
      city_id: 0,
      country_id: item.country_code,
      region_id: item.level === 'region' ? item.id : 0,
      name: item.name,
    }
  })
  
  validateInputPhone(dataStep.phone, dataStep.nationality)
  
  if (!errorsDestination.value &&
    !errorsLengthOfTrip.value &&
    !errorsNumOfTravellers.value &&
    /*!errorsBudget.value &&*/
    !errorsMonth.value &&
    !errors.email &&
    !errors.contact_name &&
    /*!errors.first_name &&
		!errors.last_name &&
		!errors.phone*/
    !phoneMsg.value) {
    
    disableSubmitButton.value = true
    
    let token
    try {
      // console.log('recaptcha')
      // const recaptcha = await load(`${useRuntimeConfig().public.siteKeyGreCaptcha}`)
      // console.log('recaptcha done', recaptcha)
      token = await recaptcha.value.execute('submit')
    } catch (e) {
      heapTrackingSubmit({
        error_location: 'TV Submit Enquiry: recaptcha error',
        error: '',
      })
      console.log('recaptcha error', e)
    }
    
    let arrival_month = getMonthNumberFromText(dataStep.month.name.replace('+', ''), ' ')
    
    let code = dataStep.nationality || getCookie('country_code=')
    let dial_code = getCountryPhone(code)
    const GTMTrackingSubmit = gtmTracking()
    
    let enquiry = {
      destinations: dest,
      arrival_month: arrival_month || '',
      arrival_month_label: dataStep.month.name || '',
      fname: dataStep.fname || '',
      lname: dataStep.lname || '',
      email: dataStep.email,
      phone: dataStep.phone ? dial_code.concat(dataStep.phone) : '',
      expert_id: route.name === 'enquiry-submit-ld' ? dataStep.expert_id : 0,
      sketch_country: getCookie('country_code'),
      sketch_feature_region: '',
      sketch_group: '',
      sketch_trip_id: route.name === 'enquiry-submit-trip' ? dataStep.tripId : '',
      sketch_source: route.path,
      affiliate_id: '',
      device: null,
      device_name: deviceInfo() || null,
      currency: getCookie('dj_curr') || null,
      budget: parseFloat(dataStep.budget.replace(/,/g, '')) || '',
      budget_currency: dataStep.currency || '',
      country_code: getCookie('country_code') || '',
      country_name: getCookie('country_name') || '',
      city_name: getCookie('city_name') || '',
      ip_address: window.client_addr || '',
      contest_gtm: GTMTrackingSubmit || null,
      redirect_url: dataStep.redirect_url,
      feature_region_id: dataStep?.feature_region_id ? dataStep?.feature_region_id : undefined,
      feature_region_name: dataStep?.feature_region_name ? dataStep?.feature_region_name : undefined,
      'g-recaptcha-response': token,
      number_traveller: dataStep.numOfTravellers,
      note: dataStep.notes || '',
      contact_name: dataStep.contactName,
      check_newsletter: dataStep.check_newsletter ? 1 : 0,
    }
    
    if (route.name === 'enquiry-submit-trip' && !dataStep.trip.name.includes('+')) {
      enquiry = {
        ...enquiry,
        length_trip: dataStep.trip.value,
      }
    } else {
      enquiry = {
        ...enquiry,
        length_trip_range: dataStep.trip.value,
      }
    }
    
    try {
      const response = await enquiryTravellerApi.submitSingleEnquiry(enquiry)
      routerBack.value = null
      phoneMsg.value = ''
      if (response?.data?.status === 200) {
        const data = response?.data?.data
        
        let dataSubmit = {
          enquiry_type: 'traveller',
          trip_selected: data?.enquiry_infos?.trip_selected || dataTripLoaded.value?.trip_name,
          url: data?.enquiry_infos?.url || dataTripLoaded.value?.trip_link,
          destinations: data?.enquiry_infos?.destinations,
          dates: data?.enquiry_infos?.dates,
          enquiry_id: data?.enquiry_id,
          expert_id: parseInt(data?.expert_id) || 0,
          firstName: dataStep.fname || data?.authenticate?.first_name,
          lastName: dataStep.lname || data?.authenticate?.last_name,
          user_type: userInfo.value.userType || data?.authenticate?.user_type,
          is_first_enquiry: data?.enquiry_infos?.is_first_enquiry,
          travellers: data?.enquiry_infos?.travellers,
          duration: data?.enquiry_infos?.duration,
          note: data?.enquiry_infos?.additional_comments,
          budget: data?.enquiry_infos?.budget,
          user_id: userInfo.value?.userId || data?.authenticate?.user_id,
        }
        
        dataSubmit = JSON.stringify(dataSubmit)
        sessionStorage.setItem('enquiry', dataSubmit)
        
        heapTrackingSubmit(data)
        
        if (!isEmpty(data?.authenticate)) {
          if (data.authenticate.user_type === 'TV') {
            const COOKIE_DURATION = 365
            
            setCookie(
              'dj_xxer_hash',
              data?.authenticate?.hash,
              COOKIE_DURATION,
            )
            setCookie('is_verified', 1, COOKIE_DURATION)
            // router.push({path: dataStep.redirect_url})
            window.location.href = data.authenticate.redirect_url || dataStep.redirect_url
            return
          } else {
            window.location.href = `${useAppConfig().publicDomainAgent}/authenticate/autologin?hash=${data.authenticate?.hash}`
            return
          }
        } else {
          router.push({ path: dataStep.redirect_url })
          return
        }
        
      } else {
        heapTrackingSubmit({
          error_location: 'TV Submit Enquiry: Submit data error',
          error: response?.data?.message,
        })
        error.value = response?.data?.message
        // messageError.value = error.value
      }
      
      disableSubmitButton.value = false
      
    } catch (error) {
      heapTrackingSubmit({
        error_location: 'TV Submit Enquiry: Submit catch error',
        error: error.message,
      })
      error.value = error.message
      disableSubmitButton.value = false
      phoneMsg.value = ''
    }
  } else {
    if (errorsDestination.value) {
      topFormRef.value?.scrollIntoView({ behavior: 'smooth' })
    } else if (errorsLengthOfTrip.value) {
      lengthOfTripRef.value?.scrollIntoView({ behavior: 'smooth' })
    } else if (errorsMonth.value) {
      monthOfTravelRef.value?.scrollIntoView({ behavior: 'smooth' })
    } else if (errorsNumOfTravellers.value) {
      numOfTravellersRef.value?.scrollIntoView({ behavior: 'smooth' })
    } else if (errors.contact_name) {
      contactNameRef.value?.scrollIntoView({ behavior: 'smooth' })
    } else if (errors.email) {
      contactEmailRef.value?.scrollIntoView({ behavior: 'smooth' })
    } else if (errors.phone) {
      contactPhoneRef.value?.scrollIntoView({ behavior: 'smooth' })
    }
  }
}

const validateInputPhone = (phone, nationality) => {
  validatePhoneNumberField('phone', phone, nationality)
  /* if((errors.phone === "This phone number does not seem to exist.") ||
		 (errors.phone === "This phone number is too long.")) {*/
  if ((errors.phone === ERROR_MESSAGE_PHONE[0]) ||
    (errors.phone === ERROR_MESSAGE_PHONE[1])) {
    phoneMsg.value = ''
  } else {
    phoneMsg.value = errors.phone
  }
}

const windowWidth = computed(() => generalStore.generalData.windowWidth)
const calculateMinBudget = (codeNew) => {
  if (currenciesListData.value) {
    const currencyDefault = currenciesListData.value.find(
      (item) => item.code === minBudgetCurrencyDefault.value,
    )
    const currencyNew = currenciesListData.value.find(
      (item) => item.code === codeNew,
    )
    minBudget.value = exchangeRate(minBudgetDefault.value, currencyDefault.rate, currencyNew.rate, false, true, false) * (dataStep.numOfTravellers || 1)
    minBudgetCurrency.value = currencyNew.symbol
    // console.log('budget',minBudgetCurrency.value,' ',minBudget.value)
  }
}

const isLDSubmit = computed(() => {
  return route.name === 'enquiry-submit-ld'
})

watch(dataStep, (val) => {
  if (val.destination.length !== 0) errorsDestination.value = false
  if (!isEmpty(val.month)) errorsMonth.value = false
  if (!isEmpty(val.trip)) errorsLengthOfTrip.value = false
  if (dataStep.numOfTravellers > 0) errorsNumOfTravellers.value = false
  // if (!isEmpty(val.budget)) errorsBudget.value =  false
  if (!isEmpty(val.email)) validateEmailField('email', val.email)
  if (!isEmpty(val.contactName)) validateNameField('contact_name', val.contactName)
  // if (!isEmpty(val.fname)) validateNameField('first_name', val.fname)
  // if (!isEmpty(val.lname)) validateNameField('last_name', val.lname)
  if (!isEmpty(val.phone) && !isEmpty(val.nationality)) {
    validateInputPhone(val.phone, val.nationality)
  }
})

watch(() => dataStep.currency, (codeNew) => {
  // console.log('watch dataStep.currency',codeNew)
  calculateMinBudget(codeNew)
  // if (parseInt(dataStep.budget) >= parseInt(minBudget.value)) errorsBudget.value = false
})

const continueStatus = ref(false)
const cancelStatus = ref(false)

const handleCountinue = () => {
  modalSeasonActive.value = false
  continueStatus.value = true
  
}
const goToHome = ref(true)

const handleCancel = () => {
  modalSeasonActive.value = false
  cancelStatus.value = true
  if (router.options.history.state.back !== null) {
    // router.push({path: `${router.options.history.state.back}`})
    router.go(-1)
  } else {
    router.push({ path: `/` })
  }
}

const handleCancelHome = () => {
  modalSeasonActive.value = false
  cancelStatus.value = true
  router.push({ path: `/` })
}
const routerBack = ref(router.options.history.state.back)
onBeforeRouteLeave((to, from, next) => {
  // console.log('routerBack.value: ',routerBack.value)
  if (to.path === routerBack.value || to.path === '/') {
    modalSeasonActive.value = true
    if (to.path === '/') {
      goToHome.value = true
    } else {
      goToHome.value = false
    }
    next(cancelStatus.value)
    // if(cancelStatus.value) {
    //     next()
    // } else {
    //     evt.preventDefault();
    //     evt.returnValue = true;
    // }
  } else {
    next()
  }
})

const getGalleryPage = async () => {
  try {
    let pageSettings = null
    let slug = `/${route.params.galleryTypes}-tours`
    if (process.server && process.PAGE_SETTINGS) {
      //let pageSettings = JSON.parse(process.PAGE_SETTINGS) || {}
      let pageSettingsList = process.PAGE_SETTINGS
      if (pageSettingsList.hasOwnProperty(slug)) {
        pageSettings = pageSettingsList[slug]
      }
    } else if (process.client && window.page_settings && window.page_settings.hasOwnProperty(slug)) {
      pageSettings = window.page_settings[slug]
    }
    
    if (!pageSettings) {
      pageSettings = (await galleryApi.getGalleryPage(`/${route.params.galleryTypes}-tours`))?.data.value?.data
      if (pageSettings && process.client) {
        if (!window.page_settings) {
          window.page_settings = {}
        }
        
        window.page_settings[slug] = pageSettings
      }
    }
    
    const country = pageSettings?.filter_options?.country_ids
    let list = []
    
    country.forEach(code => {
      let data = dataDestination.value?.find(item => item.country_code === code)
      if (data) list.push(data)
      
    })
    dataStep.destination = list
    
    if (list.length && list[0]?.name) {
      topInfo.title = `Design a Trip to ${list[0]?.name} with our Local Designers for Free`
    }
    
    if (pageSettings?.settings?.page_type === 'destination') {
      showDestination.value = false
      dataStep.feature_region_name = pageSettings?.settings?.region_name
      dataStep.feature_region_id = pageSettings?.filter_options?.region_id
    }
  } catch (e) {
    heapTrackingSubmit({
      error_location: 'TV Submit Enquiry: getGalleryPage catch error',
      error: e.message,
    })
    console.log(e)
  } finally {
    apiLoaded.value = true
  }
}

const fetchDataEnquiryOption = async () => {
  try {
    apiLoaded.value = false
    let params = {
      level: EnquiryOptionLevel.Country,
      currency: selectedCurrency.value.code,
      full: 0,
    }
    const { data: res } = await enquiryTravellerApi.getOptionsEnquiryNew(mapParamsEnquiryOption(params))
    if (res.success) {
      await mapDataEnquiryOption(res.data)
    }
  } catch (e) {
    heapTrackingSubmit({
      error_location: 'TV Submit Enquiry: fetchDataEnquiryOption catch error',
      error: e.message,
    })
    console.log(e)
  } finally {
    apiLoaded.value = true
  }
}

const mapParamsEnquiryOption = (params) => {
  switch (route.name) {
    case 'enquiry-submit-trip':
      return {
        ...params, type: EnquiryOptionType.Gallery, trip_id: route.params.trip,
      }
    case 'enquiry-submit-destination':
      return {
        ...params, type: EnquiryOptionType.Country, country_url: route.params.galleryTypes,
      }
    case 'enquiry-submit-ld':
      return {
        ...params, type: EnquiryOptionType.Designer, slug: route.params.name,
      }
    default:
      return params
  }
}

const mapDataEnquiryOption = async (data) => {
  if (data.destinations) {
    dataDestination.value = data.destinations
  }
  if (data.popular_destination) {
    popularDestinations.value = groupContinent(data.popular_destination)
  }
  
  switch (route.name) {
    case 'enquiry-submit-trip':
      desktopBanner.unshift(data?.feature_image?.url)
      tripName.value = data.trip_name
      dataStep.tripId = data.trip_id
      dataStep.destination = Object.values(data.countries)
      dataTripLoaded.value = data
      topInfo.title = `Get A Free Quote Now`
      topInfo.trip_name = data.trip_name
      topInfo.bg = data.feature_image?.url
      dataLengthTrip.value = data.trip_durations.map(({
                                                        label: name,
                                                        same_as_trip,
                                                        ...rest
                                                      }) => ({
        name: same_as_trip ? `${name} (same as selected trip)` : name,
        ...rest,
      }))
      break
    case 'enquiry-submit-destination':
      if (data.feature_image) {
        topInfo.bg = data.feature_image?.url
        desktopBanner.unshift(topInfo.bg)
      } else {
        desktopBanner.unshift(desktopFirstSlide)
      }
      await getGalleryPage()
      break
    case 'enquiry-submit-ld':
      dataStep.expert_id = data?.designer?.id
      topInfo.title = `Design a Private Trip with ${data?.designer?.name} for Free`
      topInfo.rating = (parseFloat(data?.designer?.rating) / 5) * 100
      topInfo.bg = data?.designer?.feature_image?.url
      topInfo.customers = data?.designer?.number_of_reviews
      desktopBanner.unshift(topInfo.bg)
      popularDestinations.value = []
      break
    default:
      return
  }
}

onMounted(async () => {
  await nextTick()
  // GTMTracking.value = gtmTracking()
  dataStep.currency = getCookie('dj_curr=') || 'AUD'
  const is_verified = getCookie('is_verified=')
  if (is_verified === '1') {
    try {
      const response = await accountApi.getDetailProfile(0)
      
      if (response?.data?.status === 200) {
        const userLogin = response?.data?.data
        
        disableEmail.value = true
        
        let phone = userLogin?.phone ? parsePhoneNumber(userLogin.phone) : null
        
        if (phone && phone.countryCallingCode) {
          let ctr = countries.value.find(item => {
            return item.dial_code === phone.countryCallingCode
          })
          dataStep.nationality = ctr ? ctr.code : null
        } else {
          dataStep.nationality = getCookie('country_code')
        }
        
        dataStep.email = userLogin.email
        // dataStep.fname = userLogin.first_name
        // dataStep.lname = userLogin.last_name
        dataStep.phone = phone?.nationalNumber || userLogin.phone || ''
        // dataStep.nationality = userLogin.nationality || getCookie('country_code')
        dataStep.contactName = userLogin.first_name + ' ' + userLogin.last_name
      } else {
        heapTrackingSubmit({
          error_location: 'TV Submit Enquiry: getDetailProfile data error',
          error: response?.data?.message,
        })
        error.value = response?.data?.message
      }
      
    } catch (e) {
      heapTrackingSubmit({
        error_location: 'TV Submit Enquiry: getDetailProfile catch error',
        error: e.message,
      })
      console.log(e)
    }
  }
  
  if (route.name === 'enquiry-submit-global') {
    desktopBanner.unshift(desktopFirstSlide)
  }
  
  await fetchDataEnquiryOption()
  
  recaptcha.value = await load(`${useAppConfig().siteKeyGreCaptcha}`)
  
  // if(dataStep.currency !== 'AUD') calculateMinBudget(dataStep.currency)
  // else {
  //   minBudget.value = minBudgetDefault.value
  //   minBudgetCurrency.value = selectedCurrency.value.symbol
  // }
  // // setDataStorage()
  
  // console.log('gtmTracking: ', GTMTracking.value)
  generalStore.setLoading(false)
})

</script>

<style scoped lang='scss'>
// W7-gate — mobile "How It Works?" link: was inline literal #197660 (icon fill + text), immune to
// the seam and 3.63:1 on the dark canvas. Now green in light, lifts to mint in dark via $link;
// the SVG uses fill='currentColor' so the icon follows the text colour.
.hiw-link { color: $link; }
.content-form {
  a {
    color: $link;
    text-decoration: underline !important;
  }

  @include tablet {
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 60px;
  }

  @include phone {
    padding: 0;
  }
}

.phone-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: $surface; // W7-gate: flips #0D0D0D dark (was white)
}

.tv-enquiry-submit {
  :deep(.carousel__pagination) {
    position: absolute;
    left: 0;
    top: 93px;
    z-index: 3;
    width: 100%;
    padding: 0 40px;
    display: grid;
    grid-column-gap: 4px;
    grid-template-columns: repeat(3, minmax(0, 1fr));

    .carousel__pagination-item {
    }

    .carousel__pagination-button {
      background-color: rgba(255, 255, 255, .25);
      display: block;
      font-size: 0;
      line-height: 0;
      height: 2px;

      &.carousel__pagination-button--active {
        background-color: rgba(255, 255, 255, 1)
      }
    }
  }

  .carousel__slide {
    transition: opacity 0.8s ease-in;
    position: absolute;
    height: 100%;
  }
}

.hide-dropdown {
  :deep(.custom-option) {
    display: none;
  }
}
</style>
